import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  exportExcelReq,
  END_POINTS
} from '@/api'
// import * as dayjs from 'dayjs'
import * as Lodash from 'lodash'
// import * as Constants from '@/constant'
import * as Utils from '@/utils'
import * as StoreUtils from '@/utils/StoreUtils'

const SearchInfoBean = {
  compId: '',
  projId: '',
  entityId: '',
  costColId: '',
  levelOneId: '',
  productId: '',
  spec: '',
  unit: '',
  brand: '',
  deliveryNo: '',
  stockInNo: '',
  END_SEARCH_INFO_BEAN: null
}

const InfoBean = {
  levelOneId: '',
  pdTransDt: '',
  settleDt: '', // 冗余字段的名称(非数据库字段)
  settleStartDt: '',
  settleEndDt: '',
  deliveryNo: '',
  stockInNo: '',
  productId: '',
  spec: '',
  unit: '',
  num: 0,
  priceWithTax: 0,
  vatRate: 0,
  priceWithoutTax: 0, // 冗余字段的名称(非数据库字段)
  withTaxAmt: 0, // 冗余字段的名称(非数据库字段)
  taxAmt: 0, // 冗余字段的名称(非数据库字段)
  withoutTaxAmt: 0, // 冗余字段的名称(非数据库字段)
  deductionAmt: 0, // 冗余字段的名称(非数据库字段)
  brand: '',
  inquiryDt: '',
  remarks: '',
  crtBy: '',
  crtOn: null,
  updBy: '',
  updOn: null
}

const state = {
  searchInfo: { ...SearchInfoBean },
  searchedForm: { ...SearchInfoBean },
  list: [],
  info: {
    ...InfoBean
  },
  listPagging: Utils.getDefaultListPagging(),
  pdSummaryList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  ...StoreUtils.actions,
  insertRspProjSettleMaterial({
    dispatch,
    commit,
    state,
    rootState
  }) {
    let data = {}
    Lodash.assign(data, state.info)
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.INSERT_RSP_PROJ_SETTLE_MATERIAL, {data})
        .then(res => {
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  updateRspProjSettleMaterial({
    dispatch,
    commit,
    state,
    rootState
  }) {
    let data = {}
    Lodash.assign(data, state.info)
    return new Promise((resolve, reject) => {
      putReq(END_POINTS.UPDATE_RSP_PROJ_SETTLE_MATERIAL, {data})
        .then(res => {
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  removeRspProjSettleMaterial({
    commit,
    state,
    rootState
  }, {key}) {
    return new Promise((resolve, reject) => {
      deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_SETTLE_MATERIAL + `/${key.compId}/${key.projId}/${key.entityId}/${key.transId}/${key.pdTransId}`)
        .then(res => {
          state.info = res.data
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findRspProjSettleMaterial({
    commit,
    state,
    rootState
  }, {key}) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_MATERIAL + `/${key.compId}/${key.projId}/${key.entityId}/${key.transId}/${key.pdTransId}`)
        .then(res => {
          state.info = res.data
          state.info.pdTransDt = new Date(res.data.pdTransDt)
          state.info.settleStartDt = new Date(res.data.settleStartDt)
          state.info.settleEndDt = new Date(res.data.settleEndDt)
          state.info.inquiryDt = new Date(res.data.inquiryDt)
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findRspProjSettleMaterialListByTransId({
    commit,
    state,
    rootState
  }, { compId, projId, entityId, transId }) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_MATERIAL_LIST_BY_TRANS_ID + `/${compId}/${projId}/${entityId}/${transId}`)
        .then(res => {
          state.list = res.data
          // Utils.resetListPagging(state.listPagging, res)
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findRspProjSettleMaterialList({
    commit,
    state,
    rootState
  }, { currentPage, pageSize }) {
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.FIND_RSP_PROJ_SETTLE_MATERIAL_PAGE_LIST, {
        data: {
          currentPage,
          pageSize,
          queryVO: {
            compId: state.searchedForm.compId,
            projId: state.searchedForm.projId,
            entityId: state.searchedForm.entityId,
            costColId: state.searchedForm.costColId,
            levelOneId: state.searchedForm.levelOneId,
            productId: state.searchedForm.productId,
            spec: state.searchedForm.spec,
            unit: state.searchedForm.unit,
            band: state.searchedForm.band,
            deliveryNo: state.searchedForm.deliveryNo,
            stockInNo: state.searchedForm.stockInNo
          }
        }
      }).then(res => {
        state.list = res.data
        Utils.resetListPagging(state.listPagging, res)
        StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
      }).catch(err => {
        reject(err)
      })
    })
  },
  async downloadRspProjSettleMaterialList({
    commit,
    state,
    rootState
  }) {
    let data = {
      compId: state.searchedForm.compId,
      projId: state.searchedForm.projId,
      entityId: state.searchedForm.entityId,
      costColId: state.searchedForm.costColId,
      levelOneId: state.searchedForm.levelOneId,
      productId: state.searchedForm.productId,
      spec: state.searchedForm.spec,
      unit: state.searchedForm.unit,
      band: state.searchedForm.band,
      deliveryNo: state.searchedForm.deliveryNo,
      stockInNo: state.searchedForm.stockInNo
    }

    const response = await exportExcelReq(END_POINTS.DOWNLOAD_RSP_PROJ_SETTLE_MATERIAL_LIST, {data})
    return response
  },
  findRspProjSettleMaterialSummaryByEntityId({
    commit,
    state,
    rootState
  }, { compId, projId, entityId }) {
    state.pdSummaryList = []
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_RSP_PROJ_SETTLE_MATERIAL_SUMMARY_BY_ENTITY_ID + `/${compId}/${projId}/${entityId}`)
        .then(res => {
          state.pdSummaryList = res.data
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  END_ACTIONS() {}
}

const mutations = {
  ...StoreUtils.mutations,
  resetSearchInfo(state) {
    state.searchInfo = { ...SearchInfoBean }
  },
  resetInfo(state) {
    state.info = { ...InfoBean }
  },
  addListItem(state, { index }) {
    state.list.splice(index, 0, { ...InfoBean })
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/pdtrans/rspProjSettleMaterialManage.js